import { useCallback, useState } from "react";
import useModal from "./useModal.jsx";
import useTrackingForm from "./useTrackingForm.jsx";

const useStopwatchModal = (isModalShown = false, isFormShown = false) => {
  const { isFormVisible, showForm, hideForm } = useTrackingForm(isFormShown);
  const { showModal, closeModal, isModalVisible } = useModal(isModalShown);
  const [stopwatchId, setStopwatchId] = useState(null);

  const closeForm = useCallback(() => {
    hideForm();
    setStopwatchId(null);
  }, [hideForm]);

  const openForm = useCallback(() => {
    showForm();
  }, [showForm]);

  const closeModalAndHideForm = useCallback(() => {
    closeForm();
    closeModal();
  }, [closeForm, closeModal]);

  const openModalAndShowForm = useCallback(() => {
    showForm();
    showModal();
  }, [showForm, showModal]);

  const onCommit = useCallback(
    (id) => {
      setStopwatchId(id);
      showForm();
      showModal();
    },
    [showForm, showModal]
  );

  return {
    isFormVisible,
    stopwatchId,
    setStopwatchId,
    closeForm,
    openForm,
    closeModalAndHideForm,
    openModalAndShowForm,
    onCommit,
    showModal,
    closeModal,
    isModalVisible,
  };
};

export default useStopwatchModal;
